<template>
  <b-card title="جزییات:">
    <b-row>
      <b-col cols="12" sm="4" md="4">
        <b-form-group label="تاریخ ثبت:">
          <div class="form-control disabledbutton">
            {{
              loadedDetailsUndoneRefund.created_at
                | moment("jYYYY-jM-jD HH:mm:ss")
            }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="4" md="4">
        <b-form-group label="مبلغ:">
          <div class="form-control disabledbutton">
            {{
              loadedDetailsUndoneRefund.bed != null
                ? loadedDetailsUndoneRefund.bed.toLocaleString()
                : 0
            }}
            ریال
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="4" md="4">
        <b-form-group class="" label="وضعیت:">
          <div class="form-control disabledbutton">
            {{ loadedDetailsUndoneRefund.status }}
          </div>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="4" md="4">
        <b-form-group label="کد رهگیری:">
          <b-form-input
            :disabled="
              loadedDetailsUndoneRefund.child_document != null ? true : false
            "
            v-model="details.tracking_number"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="4" md="4">
        <b-form-group label="حساب مبدا:">
          <b-form-select
            :disabled="
              loadedDetailsUndoneRefund.child_document != null ? true : false
            "
            v-model="details.bank_account_id"
            :options="options"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="4" md="4">
        <b-form-group label="تاریخ واریز:">
          <div class="form-control disabledbutton">
            {{
              loadedDetailsUndoneRefund.child_document != null
                ? loadedDetailsUndoneRefund.child_document.created_at
                : null | moment("jYYYY-jM-jD HH:mm:ss")
            }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" sm="12" md="12">
        <b-button
          v-if="
            loadedDetailsUndoneRefund.child_document != null ? false : true
          "
          @click="sendRequest"
          variant="success"
          v-b-modal.modal-2
          :class="isBusySheba ? 'spinner spinner-light spinner-right' : ''"
          >پرداخت</b-button
        >
        <b-button
          v-else
          @click="backToUndoneRefundList"
          variant="danger" 
          >بازگشت</b-button
        >
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  GET_UNDONE_REFUND_DETAILS,
  PAY_REFUND,
} from "@/core/services/store/undoneRefundDetails.module";
import httpHelper from "@/helpers/httpHelper";
import TableShowData from "@/components/table";

export default {
  name: "undoneDetails",
  data() {
    return {
      details: {
        tracking_number: null,
        bank_account_id: null,
      },
      options: [],
      id: this.$route.params.id,
      isBusySheba: false,
    };
  },
  components: {
    "list-table": TableShowData,
  },
  computed: {
    loadedDetailsUndoneRefund() {
      return this.$store.getters.loadedDetailsUndoneRefund;
    },
  },
  mounted() {
    this.getDetails();
    this.getBankList();
  },
  methods: {
    // get bank list
    getBankList() {
      httpHelper.getData("sharing/banks").then((res) => {
        let option = {};
        res.result.forEach((element) => {
          Object.assign(option, {
            value: element.detail_id,
            text: element.fa_title,
          });
          this.options.push(option);
          option = {};
        });
      });
    },
    // load data in mounted
    getDetails() {
      let id = this.$route.params.id;
      let api = "refund";
      let obj = {};
      obj = Object.assign(obj, { id: id, api: api });
      this.$store.dispatch(GET_UNDONE_REFUND_DETAILS, obj).then((data) => {
        this.details.bank_account_id = this.loadedDetailsUndoneRefund
          .child_document
          ? this.loadedDetailsUndoneRefund.child_document.doc_details[0].detail
              .id
          : null;
        this.details.tracking_number = this.loadedDetailsUndoneRefund
          .child_document
          ? this.loadedDetailsUndoneRefund.child_document.doc_details[0]
              .tracking_number
          : null;
      });
    },
    // pay refund
    sendRequest() {
      this.isBusySheba = true;
      let id = this.$route.params.id;
      let api = "refund";
      let obj = {};
      obj = Object.assign(obj, { id: id, api: api }, this.details);
      this.$store.dispatch(PAY_REFUND, obj).then((data) => {
        if (data.success == true) {
          this.isBusySheba = false;
          this.getDetails();
          this.$makeToast('success','ذخیره موفق',"ذخیره اطلاعات با موفقیت انجام شد.",5000)
        } else {
          this.$makeToast('danger','خطا',"ذخیره اطلاعات با موفقیت انجام نشد.",5000)
        }
      });
    },
    // back to UndoneRefundList
    backToUndoneRefundList(){
      this.$router.push("/undoneRefundsCharges")
    }
  },
};
</script>

<style>
.disabledbutton {
  pointer-events: none;
  opacity: 0.7;
}
</style>
